import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Card, Typography, Button, Box } from "@mui/material";
import ReportDrawer from "./ReportDrawer";
import { getReportUrlFromName } from "redux/actions/reports/reportsData";

const ReportCard = ({ report }) => {
  const dispatch = useDispatch();
  const userOrganization = useSelector((e) => e.sidebar.organisation);
  const organisationLevelReportName = useSelector(
    (e) => e.reports.organisationLevelReportName
  );
  const [typeBasedReportModal, setTypeBasedReportModal] = useState({});

  useEffect(() => {
    if (organisationLevelReportName) {
      setTypeBasedReportModal(organisationLevelReportName);
    }
  }, [organisationLevelReportName]);

  const openReportModal = async (name) => {
    dispatch(
      getReportUrlFromName({
        userOrganization,
        name: name,
      })
    );
    setTypeBasedReportModal({
      ...typeBasedReportModal,
      [name]: true,
    });
  };

  const getModelTag = (model) => {
    const map = {
      Education_V2_Reporting: "EDU",
    };
    return map[model] ? map[model] : "PDAP";
  };
  return (
    <Card
      variant="outlined"
      sx={{
        padding: "1.5rem",
        borderRadius: "5px",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        alignItems: "flex-start",
        justifyContent: "space-between",
        height: "100%",
      }}>
      <img
        width="100%"
        src={report.thumbnail ?? `/images/reports-default-thumbnail.svg`}
        alt=""
      />
      <Typography sx={{ fontSize: "18px", fontWeight: 700, color: "#2E2C34" }}>
        {report.name}
      </Typography>
      <Typography sx={{ fontSize: "14px", fontWeight: 400, color: "#757B8C" }}>
        {report.description ??
          "This report provides a comprehensive view of user interactions and engagement metrics across DoctusTech platform"}
      </Typography>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}>
        <Box>
          <Box
            key={report.report_type}
            sx={{
              backgroundColor:
                report.report_type === "EDU" ? "#E1F8FF" : "#FCE3AD",
              color: report.report_type === "EDU" ? "#2BBDF0" : "#B78518",
              fontWeight: 700,
              fontSize: "14px",
              border: "1px solid #2BBDF0",
              padding: "2px 10px 2px 10px",
              borderRadius: "5px",
            }}>
            {report.report_type}
          </Box>
        </Box>
        <Button
          onClick={() => openReportModal(report.name)}
          sx={{
            marginLeft: "auto",
            fontWeight: 500,
            fontSize: "14px",
            color: "#2BBDF0",
          }}
          variant="text">
          View Report <img src="/images/arrow-right.svg" alt="" />
        </Button>
      </Box>
      {typeBasedReportModal[report.name] && (
        <ReportDrawer
          open={typeBasedReportModal[report.name]}
          handleClose={() =>
            setTypeBasedReportModal({
              ...typeBasedReportModal,
              [report.name]: false,
            })
          }
        />
      )}
    </Card>
  );
};
export default ReportCard;
